import React, { useEffect } from "react";
import { SitesFiltersInput } from "../../../__generated__/globalTypes";
import { useSites } from "../hooks";
import { Globe } from "lucide-react";
import { Card } from "../../../components/cards";

export const SitesInfos: React.FC<SitesFiltersInput> = (where) => {
  const { data, loading } = useSites({ where });

  return (
    <Card hover padding="sm" className="shadow-sm border border-gray-200">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
            Cibles
          </p>
          <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
            {loading ? "Loading..." : data?.sites?.total || 0}{" "}
          </p>
          <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
            Cibles surveillées
          </p>
        </div>
        <div className="bg-blue-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
          <Globe className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
        </div>
      </div>
    </Card>
  );
};
